var ltr6_module_print = (function (ltr6_module_print) {

    ltr6_module_print.init = function(){
      // var _print = window.print;
      // window.print = function() {
      //   console.log('about to print');
      //   var src = $('img.lazyload').attr('data-src');
      //   $('img.lazyload').attr('src',src);

      //   // do stuff
      //   _print();
      // }




      var beforePrint = function() {
          // console.log("before print");
          $.each($('img.lazyload'), function(index, val) {
            var src = $(this).attr('data-src');
            $(this).attr('src',src);
          });
      };
      var afterPrint = function() {
          // console.log("after print");
      };

      var launchedFromMenu = true;
      if (window.matchMedia) {
          var mediaQueryList = window.matchMedia('print');
          mediaQueryList.addListener(function(mql) {
              if (mql.matches) {
                  if(launchedFromMenu) {
                      // https://bugs.chromium.org/p/chromium/issues/detail?id=571070
                      // alert("There is a bug in Chrome/Opera and printing via the main menu does not work properly. Please use the 'print' icon on the page.");
                  }
                  beforePrint();
              } else {
                  afterPrint();
              }
          });
      }

      // These are for Firefox
      window.onbeforeprint = beforePrint;
      window.onafterprint = afterPrint;

      function printPage() {
          window["beforePrint"]();
          launchedFromMenu = false;
          window.print();

      }



    };

    return ltr6_module_print;
}(ltr6_module_print || {}));